import styled from 'styled-components';
import {Color} from '../../tokens/colors';

const StyledNaming = styled.div`
    margin-right: 24px;

    @media (max-width: 767px) {
        margin-right: 0;
    }
`;

const StyledNumber = styled.p`
    font-weight: 700;
    font-size: 16px;
    line-height: 1.2;
    color: ${Color.BLACK};
`;

const OrderName = ({number}) => {
    return (
        <StyledNaming>
            <StyledNumber>Заказ {number}</StyledNumber>
        </StyledNaming>
    );
};

export {OrderName};
